import { signal } from "@westpierstudio/luma/utils";
import { Action } from "@westpierstudio/luma/utils/flow/Action";
import { Signal, SignalBinding } from "type-signals";

/**
 * Dispatches the given signal with the given arguments
 */
export class SignalBlockAllAction<SignalType extends Signal> extends Action {

    private signals: SignalType[];
    private completed = 0;
    private bindings: SignalBinding[] = [];

    constructor(...signals: SignalType[]) {
        super();
        this.signals = signals;
    }

    run() {
        this.completed = 0;
        this.bindings = this.signals.map((signal) => signal.once(this.checkComplete, this));
    }

    checkComplete() {
        this.completed++;
        if (this.completed === this.signals.length) this.complete();
    }

    destroy(): void {
        this.bindings.forEach((b) => b.dispose());
        this.bindings.length = 0;
    }

    override toString() {
        return `SignalBlockAllAction`;
    }
}